import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=249f4d34&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"
import style0 from "./scss/Dashboard.scss?vue&type=style&index=0&id=249f4d34&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "249f4d34",
  null
  
)

export default component.exports